document.addEventListener('DOMContentLoaded', () => {

  /* -----------------------------
   Dropdown toggle
  ----------------------------- */
  document.addEventListener('click', e => {
    const toggle = e.target.closest('.dropdown-toggle');
    if (!toggle) return;

    e.preventDefault();

    const targetId = toggle.getAttribute('href')?.slice(1);
    if (!targetId) return;

    const target = document.getElementById(targetId);
    if (!target) return;

    const expanded = toggle.getAttribute('aria-expanded') === 'true';

    toggle.setAttribute('aria-expanded', (!expanded).toString());
    target.classList.toggle('show', !expanded);
  });

  /* -----------------------------
   Show more / less
  ----------------------------- */
  (() => {
    const initialized = new WeakSet();

    const init = wrapper => {
      if (initialized.has(wrapper)) return;
      initialized.add(wrapper);

      const content = wrapper.querySelector('[data-show-more-content]');
      const toggle = wrapper.querySelector('[data-show-more-toggle]');
      if (!content || !toggle) return;

      const { labelMore, labelLess } = wrapper.dataset;

      toggle.addEventListener('click', () => {
        const expanded = toggle.getAttribute('aria-expanded') === 'true';

        wrapper.classList.toggle('is-collapsed', expanded);
        toggle.setAttribute('aria-expanded', (!expanded).toString());
        toggle.textContent = expanded ? labelMore : labelLess;
      });
    };

    const observer = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              init(entry.target);
              observer.unobserve(entry.target);
            }
          });
        },
        {
          rootMargin: '200px 0px' // ініціалізуємо трохи ДО появи
        }
    );

    document.querySelectorAll('[data-show-more-wrapper]').forEach(wrapper => {
      observer.observe(wrapper);
    });
  })();

  /* -----------------------------
   FAQ accordion
  ----------------------------- */
  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-faq-toggle]');
    if (!btn) return;

    const expanded = btn.getAttribute('aria-expanded') === 'true';
    const content = btn.parentElement.querySelector('[data-faq-content]');
    if (!content) return;

    btn.setAttribute('aria-expanded', (!expanded).toString());
    content.style.display = expanded ? 'none' : 'block';
  });

  /* -----------------------------
   Variant change (price update)
  ----------------------------- */
  document.addEventListener('change', e => {
    const radio = e.target.closest('input[type="radio"][data-variant-id]');
    if (!radio) return;

    const card = radio.closest('.card-wrapper.product-card-wrapper');
    if (!card) return;

    const priceWrapper = card.querySelector('.price');
    if (!priceWrapper) return;

    const price = Number(radio.dataset.variantPrice) / 100;
    const compare = radio.dataset.variantCompare
        ? Number(radio.dataset.variantCompare) / 100
        : null;

    const available = radio.dataset.variantAvailable === 'true';
    const unitPrice = radio.dataset.unitPrice
        ? Number(radio.dataset.unitPrice) / 100
        : null;
    const unitRef = radio.dataset.unitReference || 'kg';

    const formatPrice = val =>
        new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: window.Shopify?.currency?.active || 'EUR'
        }).format(val);

    const unitPriceHTML = unitPrice
        ? `
        <small class="unit-price caption">
          <span class="price-item price-item--last">
            <span>${formatPrice(unitPrice)}</span>
            <span aria-hidden="true"> / </span>
            <span>${unitRef}</span>
          </span>
        </small>`
        : '';

    if (compare && compare > price) {
      const discount = Math.round(((compare - price) / compare) * 100);

      priceWrapper.classList.add('price--on-sale');
      priceWrapper.innerHTML = `
        <div class="price__container">
          <div class="price__regular">
            <span class="price-item price-item--regular">${formatPrice(price)}</span>
          </div>
          <div class="price__sale">
            <s class="price-item price-item--regular">${formatPrice(compare)}</s>
            <span class="price-item price-item--sale price-item--last">${formatPrice(price)}</span>
          </div>
          ${unitPriceHTML}
        </div>
        <span class="badge price__badge-sale" style="background:#F6BF3F;color:#000;">
          -${discount}%
        </span>
        <span class="badge price__badge-sold-out color-scheme-3" style="${available ? 'display:none;' : ''}">
          Sold out
        </span>`;
    } else {
      priceWrapper.classList.remove('price--on-sale');
      priceWrapper.innerHTML = `
        <div class="price__container">
          <div class="price__regular">
            <span class="price-item price-item--regular">${formatPrice(price)}</span>
          </div>
          ${unitPriceHTML}
        </div>
        <span class="badge price__badge-sold-out color-scheme-3" style="${available ? 'display:none;' : ''}">
          Sold out
        </span>`;
    }

    const atcBtn = card.querySelector('.custom-atc-btn');
    if (atcBtn) {
      atcBtn.dataset.varAtcId = radio.dataset.variantId;
    }
  });

});

/* -----------------------------
 Add to cart (delegated)
----------------------------- */
document.addEventListener('click', e => {
  const btn = e.target.closest('.custom-atc-btn');
  if (!btn) return;

  e.preventDefault();

  const spinner = btn.querySelector('.loading__spinner');
  btn.classList.add('loading');
  btn.disabled = true;
  spinner?.classList.remove('hidden');

  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  if (!cart) return;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: btn.dataset.varAtcId,
      quantity: 1,
      sections: cart.getSectionsToRender().map(s => s.id)
    })
  })
      .then(r => r.json())
      .then(resp => {
        cart.renderContents(resp);
        document.querySelector('cart-drawer')?.classList.remove('is-empty');
      })
      .finally(() => {
        spinner?.classList.add('hidden');
        btn.disabled = false;
        btn.classList.remove('loading');
      });
});
